var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isCustomerVaultEnabled)?_c('PaidFeatureNotEnabled',{attrs:{"header":_vm.config.pageTitle,"feature":"Customer Vault"}}):_c('EntitiesTable',{attrs:{"config":_vm.config,"showActions":"","showViewButton":"","showDownloadCsvButton":false},scopedSlots:_vm._u([{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dateTimeFull")(item.createdAt))+" ")]}},{key:"item.id",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("uuidLast12")(item.id))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }